<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>当前积分：{{point}}</span>
            <a-button type="primary" style="margin-left: 15px" @click="$refs.payModal.showForm('赠送积分给顾客', {point})">积分赠送</a-button>
        </div>
        <a-divider>赠送记录</a-divider>
        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                style="width: 70%; margin-left: 15%"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

        </a-table>
        <pay-modal ref="payModal" @pay="handlePay"></pay-modal>
    </div>
</template>

<script>

    import vendorAdminService from "@/service/vendorAdmin";
    import moment from "moment"
    import PayModal from "./PayModal";

    export default {
        components: {PayModal},
        data() {
            return {
                columns: [
                    {title: '#', width: "10%", scopedSlots: { customRender: 'serial' }},
                    {title: '顾客昵称',width: "21%", dataIndex: 'relatedName',},
                    {title: '消费金额',width: "12%", dataIndex: 'consumeAmount', customRender: (text) => text + "元"},
                    {title: '赠送积分',width: "12%", dataIndex: 'amount', customRender: (text) => text + "积分"},
                    {title: '余额',width: "12%", dataIndex: 'balance', customRender: (text) => text + "积分"},
                    {title: '创建时间',width: "20%", dataIndex: 'createTime', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                ],
                rows: [],
                pagination: {},

                point: 0
            }
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            handlePointPay() {
                const h = this.$createElement
                this.$info({
                    title: '积分购买',
                    content: h('div', {}, [
                        h('p', '您好，请联系我们的工作人员购买积分'),
                        h('br'),
                        h('p', 'tel：15500000001（张女士）'),
                    ]),
                    onOk() {},
                    okText: "知道了"
                });
            },
            fetch(params) {
                vendorAdminService.bonusPayList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.record.records

                    for(let row of this.rows) {
                        row.consumeAmount = JSON.parse(row.extInfo).consumeAmount
                    }

                    pagination.current = res.data.record.current
                    pagination.total = res.data.record.total
                    pagination.pageSize = res.data.record.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }

                    this.point = res.data.point
                    this.pagination = pagination
                });
            },
            handlePay(payInfo) {
                vendorAdminService.doBonusPay(
                    payInfo
                ).then((res)=>{
                    this.$success({
                        title: "赠送成功！"
                    })
                    this.$refs.payModal.confirmLoading = false
                    this.$refs.payModal.visible = false

                    this.fetch({
                        pageNo: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        keyword: this.keyword
                    })
                }).catch((res)=>{
                    this.$refs.payModal.confirmLoading = false
                })

            }
        }
    }
</script>

<style scoped>

</style>
